import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Document } from '@models/entities/combosData';
import { TranslationService } from '@providers/translation-new/translation.service';
import { SharedService } from '@providers/shared/shared.service';
import { EIcons } from '@passer-technologies/components';

@Component({
  selector: 'app-load-file',
  templateUrl: './load-file.html',
  standalone: false
})
export class LoadFileComponent {
  @Input() classDiv: string;
  @Input() icon: EIcons;
  @Input() iconClass = '';
  @Input() iconColor = 'blue';
  @Input() text: string;
  @Input() accept: string;
  @Input() acceptLower: string[];
  @Input() disable: number;
  @Input() doc: Document[] = [];
  @Output() clickAction = new EventEmitter();

  icons = EIcons;

  constructor(
    private sharedService: SharedService,
    private translation: TranslationService
  ) {}

  onFileSelectedDoc(event): FileReader {
    if (this.doc.length < this.disable) {
      const selectedFile = event.target.files[0],
        reader = new FileReader();
      reader.onload = fileLoaded => {
        const f = selectedFile.type.split('/');
        const {
          alerts: { sizeImage },
          actions: { inv_Form },
        } = this.translation.getLangMessagesByKeys(['alerts', 'actions']);
        if (selectedFile.size <= 10000000) {
          if (f.length > 1 && this.acceptLower.includes(f[1].toLowerCase())) {
            this.doc.push({
              name: selectedFile.name,
              base64: fileLoaded.target.result as any,
              extension: `.${f[1]}`,
            });
            this.clickActionMethod();
          } else {
            this.sharedService.showSnackBar('', inv_Form);
          }
        } else {
          this.sharedService.showSnackBar('', sizeImage);
        }
      };

      reader.readAsDataURL(selectedFile);
      return reader;
    }
  }

  deleteDoc(indexD: number): void {
    this.doc.splice(indexD, 1);
    this.clickActionMethod();
  }

  clickActionMethod(): void {
    this.clickAction.emit(this.doc);
  }
}
